import request from '@/utils/request'


// 查询用户睡眠列表
export function listSleep(query) {
  return request({
    url: '/joe/user-sleep/list',
    method: 'get',
    params: query
  })
}

// 查询用户睡眠分页
export function pageSleep(query) {
  return request({
    url: '/joe/user-sleep/page',
    method: 'get',
    params: query
  })
}

// 查询用户睡眠详细
export function getSleep(data) {
  return request({
    url: '/joe/user-sleep/detail',
    method: 'get',
    params: data
  })
}

// 新增用户睡眠
export function addSleep(data) {
  return request({
    url: '/joe/user-sleep/add',
    method: 'post',
    data: data
  })
}

// 修改用户睡眠
export function updateSleep(data) {
  return request({
    url: '/joe/user-sleep/edit',
    method: 'post',
    data: data
  })
}

// 删除用户睡眠
export function delSleep(data) {
  return request({
    url: '/joe/user-sleep/delete',
    method: 'post',
    data: data
  })
}
